import React from 'react';
import styles from './styles.module.scss';

const HeadingWrapper = ({ children }) => (
    <div className={styles.HeadingWrapper}>{ children }</div>
);

export default HeadingWrapper;
